import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import FinalArrow from 'components/FinalArrow';
import { dti } from 'helpers/cmp';

const DifferentialText = ({
  display,
  difference,
  isPositive,
  fontSizeClass,
  datatestid,
  displayClassName,
  displayZeroDifferenceText,
}) => {
  let colorClass = isPositive ? 'fontGreen300' : ' fontRed100';

  let finalDisplay = '';
  if (difference === 0.0) {
    if (displayZeroDifferenceText === '') {
      finalDisplay = '';
    } else {
      finalDisplay = displayZeroDifferenceText;
    }
    colorClass = 'fontGray200';
  } else {
    finalDisplay = display;
  }

  return (
    <span className={classnames(colorClass, fontSizeClass)}>
      <FinalArrow difference={difference} isPositive={isPositive} />
      <div
        data-testid={dti(datatestid, 'value')}
        className={classnames(displayClassName, colorClass, 'inblock')}
      >
        {finalDisplay}
      </div>
    </span>
  );
};

DifferentialText.propTypes = {
  display: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  difference: PropTypes.number.isRequired,
  isPositive: PropTypes.bool.isRequired,
  fontSizeClass: PropTypes.string,
};

DifferentialText.defaultProps = {
  display: '',
  difference: 0.0,
  isPositive: false,
  fontSizeClass: 'text-16',
  displayClassName: '',
};

export default DifferentialText;
